import { Component, HostBinding, Output, EventEmitter } from '@angular/core';
import { PropertyService } from '../shared/property.service';

declare var ol: any;

@Component({
  selector: 'sold-central',
  templateUrl: './central.component.html',
  styleUrls: ['./central.component.scss']
})
export class CentralComponent {

  @Output() openNav = new EventEmitter();
  @HostBinding('attr.theme') theme = 'HRT';
  showMore: boolean = false;

  icon: any;
  map: any;

  testClass = '';

  constructor(public _propertyService: PropertyService) { }

  openSideNav() {
    this.openNav.emit();
  }

  showMoreText() {
    this.showMore = true;
  }

  showLess() {
    this.showMore = false;
  }

}



// WEBPACK FOOTER //
// D:/FLINK/FlinkViewingPageDec2020/NewLandingPage/src/app/central/central.component.ts